import React, { useState } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "../../assets/css/login.scss";

import { Button, Error, Image, Input, Label } from "../../Components";
import Icon from "../../assets/icons/Icon";
import { loginUser } from "../../store/user/user-action";
import { verifyCodeSchema } from "../../Schema/LoginSchema";
import { FaRegUserCircle } from "react-icons/fa";
import { API_POST_VERIFYLOGIN2FA } from "../../utils/api/ApiConstant";
import { postAxios } from "../../Services/commonService";
import { userAction } from "../../store/user/user-slice";
import { decodeToken } from "../../helper/common";
import { dispatch } from "../../store";

const VerifyCode = () => {
  const location = useLocation();
  const payload = location.state;

  const { isLoading } = useSelector((state) => state.ui);
  const { values, touched, errors, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        code: "",
      },
      validationSchema: verifyCodeSchema,
      onSubmit: async (values) => {
        const param = {
          code: values.code,
          username: payload.Username,
          deviceId: "test",
        };
        const data = await postAxios({
          url: API_POST_VERIFYLOGIN2FA,
          payload: param,
        });

        if (data) {
          dispatch(userAction.setToken(data?.accessToken));
          dispatch(userAction.setSToken(data?.sToken));
          dispatch(userAction.setSurl(data?.sUrl));

          // decode token here and store
          const res = decodeToken(data?.accessToken);
          dispatch(userAction.updateUser(res));
        }
      },
    });

  return (
    <>
      <section className="login_app">
        <div className="login-container">
          <div className="login-header">
            <div className="logo_img">
              <a href="#">
                <Image
                  className="logo_icon"
                  src="/assets/images/logo.svg"
                  alt="logo icon"
                />
              </a>
            </div>
            <p>Verify Code</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <Label className="form-label" for="code">
                Code
              </Label>

              <FaRegUserCircle className="icon_box" />

              <Input
                type="text"
                className="form-control"
                id="code"
                name="code"
                placeholder="Enter code"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.code}
                autoFocus
              />
              {errors.code && touched.code && <Error>{errors.code}</Error>}
            </div>

            <div className="input-group">
              <Button
                className="login-button"
                type="submit"
                // icon="FaSignInAlt"
                isDisabled={isLoading}
              >
                Verify
              </Button>
            </div>
          </form>
          <div className="form-footer">
            <p>
              This is Trading Application with full trading features, designed
              solely for educational purposes.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default VerifyCode;
